function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5065_21003)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-38.5629 -38.9788L-4.0412 55.3077L10.0337 33.5786L-38.5629 -38.9788Z",
  fill: "#99D6EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4609 4.96434L25.4026 16.4259L53.7441 0.384766L-38.5625 -38.9779L28.4609 4.96434Z",
  fill: "#FFB81C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.3728 14.4162L10.0339 33.5786L17.5722 45.1526L25.4025 16.425L22.3728 14.4162Z",
  fill: "#99D6EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-38.5625 -38.9785L10.0341 33.5789L22.373 14.4164L-38.5625 -38.9785Z",
  fill: "#00A9E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4023 16.4262L28.4606 4.9646L22.3727 14.4174L25.4023 16.4262Z",
  fill: "#AFA96E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4607 4.96446L-38.5627 -38.9777L22.3728 14.4172L28.4607 4.96446Z",
  fill: "#A09958"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5065_21003"
}, /*#__PURE__*/React.createElement("rect", {
  width: 99.6536,
  height: 99.6536,
  fill: "white",
  transform: "translate(65.8867 -0.769531) rotate(136.454)"
})));

function SvgSvgviewerOutputModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgviewerOutputModal);
export default __webpack_public_path__ + "static/media/svgviewer-output-modal.bce1c6c1.svg";
export { ForwardRef as ReactComponent };